import { getBusiness } from 'lib/api';
import { getSupplierTenders } from 'lib/api/publicMarket';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import { Tender } from 'lib/types/models';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { AppDispatch } from 'services/redux/store';

import { AwardedTendersTable } from './components/AwardedTenders';
import { StatsResponse, TendersStats } from './components/TendersStats';

const PublicMarket: React.FC = () => {
  const { id, page } = useParams<{ id: string; page: string }>();
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [tenders, setTenders] = useState<Tender[]>([]);
  const [stats, setStats] = useState<StatsResponse | null>(null);
  const [startValue, setStartValue] = useState(0);

  const tabs = useMemo<
    { id: number; label: string; component: React.JSX.Element; path: string }[]
  >(
    () => [
      {
        id: 1,
        label: 'Estadísticas',
        component: <TendersStats stats={stats} />,
        path: 'stats',
      },
      {
        id: 2,
        label: 'Licitaciones Adjudicadas',
        component: <AwardedTendersTable tenders={tenders} />,
        path: 'awarded',
      },
    ],
    [tenders, stats],
  );

  const handleNavigation = (index: number) => {
    if (!id) return;
    navigate(`/companies/${id}/publicMarket/${tabs[index].path}`);
  };

  const fetchData = async () => {
    if (!id) {
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const business = await getBusiness(dispatch, id);
      const identifier: string = business?.identifier || id;
      const response = await getSupplierTenders(dispatch, identifier);
      setTenders(response?.tenders || []);
      setStats(response?.stats || null);
      const start = tabs.findIndex((x) => x.path === page);
      setStartValue(start === -1 ? 0 : start);
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  useEffect(() => {
    void fetchData();
  }, []);

  if (loading) return <CenteredCircularProgress />;

  return (
    <EnhancedTab
      tabType="secondary"
      startValue={startValue}
      tabs={tabs}
      onTabChange={handleNavigation}
    />
  );
};

export default PublicMarket;
